module.exports = __webpack_public_path__ + "img/404.fe31010e.svg";